import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "impersonate flex flex-align-center full-height",
  ref: "root"
}
const _hoisted_2 = { class: "full-width" }
const _hoisted_3 = {
  class: "impersonate__label",
  for: "impersonate-company"
}
const _hoisted_4 = { class: "impersonate__autocomplete mb-2" }
const _hoisted_5 = ["value", "placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "impersonate__options"
}
const _hoisted_7 = ["onMousedown"]
const _hoisted_8 = {
  key: 0,
  class: "impersonate__empty"
}
const _hoisted_9 = {
  class: "impersonate__label",
  for: "impersonate-user"
}
const _hoisted_10 = { class: "impersonate__autocomplete mb-2" }
const _hoisted_11 = ["value", "placeholder", "disabled"]
const _hoisted_12 = {
  key: 0,
  class: "impersonate__options"
}
const _hoisted_13 = ["onMousedown"]
const _hoisted_14 = {
  key: 0,
  class: "impersonate__empty"
}
const _hoisted_15 = { class: "flex flex-justify-end" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('IMPERSONATE.TITLE')), 1),
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('COMMON.COMPANY')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          class: "impersonate__search",
          id: "impersonate-company-search",
          value: _ctx.companySearch,
          placeholder: _ctx.$t("IMPERSONATE.COMPANY_PLACEHOLDER"),
          autocomplete: "off",
          onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCompanyDropdown && _ctx.openCompanyDropdown(...args))),
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCompanySearch && _ctx.onCompanySearch(...args)))
        }, null, 40, _hoisted_5),
        (_ctx.isCompanyDropdownOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCompanyOptions, (company) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: "impersonate__option",
                  key: company.id,
                  type: "button",
                  onMousedown: _withModifiers(($event: any) => (_ctx.selectCompany(company)), ["prevent"])
                }, _toDisplayString(company.title), 41, _hoisted_7))
              }), 128)),
              (_ctx.filteredCompanyOptions.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('COMPANY.ADD_COMPANY.NO_DATA')), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('COMMON.USER')), 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("input", {
          class: "impersonate__search",
          id: "impersonate-user-search",
          value: _ctx.userSearch,
          placeholder: _ctx.$t("IMPERSONATE.USER_PLACEHOLDER"),
          disabled: !_ctx.companyId || _ctx.userOptions.length === 0,
          autocomplete: "off",
          onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openUserDropdown && _ctx.openUserDropdown(...args))),
          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onUserSearch && _ctx.onUserSearch(...args)))
        }, null, 40, _hoisted_11),
        (_ctx.isUserDropdownOpen && _ctx.companyId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUserOptions, (user) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: "impersonate__option",
                  key: user.id,
                  type: "button",
                  onMousedown: _withModifiers(($event: any) => (_ctx.selectUser(user)), ["prevent"])
                }, _toDisplayString(_ctx.formatUserOption(user)), 41, _hoisted_13))
              }), 128)),
              (_ctx.filteredUserOptions.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('COMPANY.ADD_COMPANY.NO_DATA')), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          class: "impersonate__submit",
          type: "button",
          disabled: !_ctx.userId,
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startImpersonateMode && _ctx.startImpersonateMode(...args)))
        }, _toDisplayString(_ctx.$t('COMMON.NEXT')), 9, _hoisted_16)
      ])
    ])
  ], 512))
}